import styled from 'styled-components';

export default function HostMicMutedBadge() {
  return <Badge>
    <svg aria-hidden="true" width="20" height="20" viewBox="0 0 32 32"
      fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round">
      <rect x="13" y="5" width="6" height="13" rx="3" />
      <path d="M9 13v2a7 7 0 0 0 14 0v-2M16 22v5M12 27h8M6 5l21 22" />
    </svg>
    셀러 마이크 꺼짐
  </Badge>;
}

const Badge = styled.div`
  display: inline-flex;
  align-items: center;
  flex-shrink: 0;
  margin-top: var(--space-4, 16px);
  gap: var(--space-2, 8px);
  padding: var(--space-2, 8px) var(--space-3, 12px);
  border: 1px solid var(--color-border-strong, #5A5A60);
  border-radius: var(--radius-full, 999px);
  background: var(--color-bg-overlay, rgba(0, 0, 0, 0.72));
  color: var(--color-text-on-brand, #FFFFFF);
  font-family: var(--font-family-base, var(--font-Pretendard-Regular));
  font-size: calc(var(--text-body, 14px) * var(--studio-font-scale, 1));
  font-weight: 500;
  line-height: 1.4;
  svg { flex-shrink: 0; }
`;
